import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {FieldSectionsWithFirstSectionResponseModel} from '../models/field-sections-response.model';
import {VirtualGridItemResponse} from '../models/virtual-grid-models';

@Injectable()
export class SmartGridV2ApiService {
  constructor (private httpClient: HttpClient) {}

  getFieldSectionDetails(): Observable<FieldSectionsWithFirstSectionResponseModel> {
    const url: string = '';
    const query = {};
    return this.httpClient.post<FieldSectionsWithFirstSectionResponseModel>(url, query);
  }

  getItems() {
    const url = '';
    const request = {};
    return this.httpClient.post<VirtualGridItemResponse>(url, request);
  }
}
